import React, { FC } from 'react'

const ChatBubble: FC<DefaultPropsIcon> = (props) => {
  const { size = 24, onClick, className, color = '#818C99' } = props
  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      <svg width={size} height={size} viewBox="16 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70 6C97 6 119 25.6 119 50C119 74.4 97 94 70 94C62.3 94 55 92.4 48.5 89.5L27.8 94C24 94.8 21.1 91.6 22.3 88.1L27.7 70.1C23.5 64 21 57.2 21 50C21 25.6 43 6 70 6ZM70 15C48.3 15 30 30.4 30 50C30 56.4 32.1 62.2 36.1 67.6L37.5 69.4L33.2 83.6L49.5 80.1L51 80.8C56.7 83.5 63.1 85 70 85C92.2 85 110 69.4 110 50C110 30.6 92.2 15 70 15Z"
          fill={color}
        />
      </svg>
    </span>
  )
}

export default ChatBubble
